import { createSlice } from "@reduxjs/toolkit";
import { programApi } from "./program.api";
// Api response type
const initialState = {
    dictionary: {}
};
export const programSlice = createSlice({
    name: "program",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(programApi.endpoints.getProgram.matchFulfilled, (state, action) => {
            return Object.assign(Object.assign({}, state), action.payload);
        });
    }
});
//# sourceMappingURL=program.slice.js.map